module.exports = __webpack_public_path__ + "static/media/ilkley-17.8b923a5b.jpg";